import {Component, input} from '@angular/core';

@Component({
  selector: 'app-card-element',
  standalone: true,
  imports: [],
  templateUrl: './card-element.component.html',
  host: {
    '[class]': "'flex flex-col space-y-1 '"
  }
})
export class CardElementComponent {
    label  = input<string>('');
}
